import React from 'react';
import ContentContainer from '../components/content-container';
import Title from '../components/title';

// Temporary interface - this should be added to Contentful and regenerated in global.d.ts
interface ISectionPersonioIframeFields {
  /** Title */
  title?: string | undefined;
  /** Iframe URL */
  iframeUrl?: string | undefined;
  /** Height in pixels */
  height?: number | undefined;
  /** Background Color */
  backgroundColor?: "gray" | "white" | undefined;
  /** Disable Spacing */
  disableSpacing?: boolean | undefined;
  /** Hide Title */
  hideTitle?: boolean | undefined;
}

const PersonioIframe: React.FC<ISectionPersonioIframeFields> = ({
  title,
  iframeUrl,
  height,
  backgroundColor,
  disableSpacing,
  hideTitle,
}) => {
  const iframeHeight = height || 1100;
  const url = iframeUrl || 'https://pets-deli.jobs.personio.de';

  return (
    <ContentContainer
      disableSpacing={disableSpacing}
      backgroundColor={backgroundColor || 'white'}
    >
      {title && hideTitle !== true && <Title>{title}</Title>}
      <div className="w-full">
        <iframe
          src={url}
          width="100%"
          height={`${iframeHeight}px`}
          frameBorder="0"
          title={title || 'Career Opportunities'}
          style={{ border: 'none', minHeight: `${iframeHeight}px` }}
          loading="lazy"
        />
      </div>
    </ContentContainer>
  );
};

export default PersonioIframe;